module.exports = __webpack_public_path__ + "static/media/10.b769c271.jpg";